module.exports = __webpack_public_path__ + "img/bg4.eb1f4a5d.png";